import React from 'react';

import { CLASSNAME, TITLE } from './Title-constants';

const ViewComponent = () => <p className={CLASSNAME}>{TITLE}</p>;

ViewComponent.displayName = 'Banner-Title-view';

export default ViewComponent;
